<template>
    <div id="atmo-contract" class="atmo-hash-jump-point atmo-content-group">
        <h3>Контракт</h3>

        <ul v-if="!pivc.isPurchaseOutATMO" class="atmo-content-block-2-columns atmo-no-item-separator">
            <li v-if="this.$props.purchaseitem.plain.is_first_contract === false" class="mb-2 pb-2">
                <dt>Контракт со вторым местом. Причина:</dt>
                <dd v-text="this.$props.purchaseitem.plain.first_contract_status_title"></dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>Предмет контракта - наименование закупочной сессии:</dt>
                <dd v-text="this.$props.purchaseitem.description"></dd>
            </li>
            <li v-if="this.$props.purchaseitem.customer_contract_number" class="mb-2 pb-2">
                <dt>Номер контракта в системе учета заказчика:</dt>
                <dd v-text="this.$props.purchaseitem.customer_contract_number"></dd>
            </li>
            <li v-if="this.$props.purchaseitem.contract.hasDeliveryCost()" class="mb-2 pb-2">
                <dt>Стоимость доставки, руб.:</dt>
                <dd>{{ this.$props.purchaseitem.contract.delivery_cost | formatnumber }}</dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>Цена контракта, руб.:</dt>
                <dd>{{ this.$props.purchaseitem.contract.price_total | formatnumber }}</dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>Статус контракта:</dt>
                <dd>
                    <span v-text="this.$props.purchaseitem.contract.acceptance_status_title"></span>
                </dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>Статус закупки:</dt>
                <dd v-text="this.$props.purchaseitem.status_title"></dd>
            </li>
        </ul>

        <send-second-offer-contract v-if="pivc.isUserEngagedCustomer && pivc.purchaseitem.allow_second_offer_contract" :purchase-item="pivc.purchaseitem.plain" @refresh="refresh" />
    </div>
</template>

<script>
import SendSecondOfferContract from '@/components/products/fl44/partials/send-second-offer-contract.vue';

export default {
    components: {
        SendSecondOfferContract
    },
    props: {
        pivc: { required: true, type: Object },
        purchaseitem: { required: true, type: Object }
    },
    methods: {
        refresh() {
            this.$router.push({ name: this.$route.name, params: this.$route.params, hash: '#atmo-contract' }).finally(() => window.location.reload());
        }
    }
};
</script>
